export const CenterRow = ({ children }) => {
  return <div className="mb-2 flex gap-6">{children}</div>;
};
